export default "__VITE_ASSET__CAUanlCO__"